var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('f7-navbar',{attrs:{"no-shadow":true}},[_c('f7-nav-left',{attrs:{"color-theme":"white","back-link":"返回"}}),_vm._v(" "),_c('f7-nav-title',[_vm._v("智能报表")])],1),_vm._v(" "),_c('div',{staticClass:"has-content",staticStyle:{"padding":"0rem 0rem"}},[_c('div',[_c('img',{attrs:{"src":require("@/assets/img/report.png"),"width":"100%"}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ac6459d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/report/index.vue
// module id = null
// module chunks = 